import React, { ReactElement } from 'react';
import { useLocation } from 'react-router';
import { Heading } from 'idsk-react-components';
import Layout from '../Layout';
import './addPripomienkaPage.scss';
import ClassType from '../../model/pripomienka/ClassType';
import AddPripomienka from '../../module/AddPripomienka';
import routes from '../../routing/routes';
import UserRole from '../../model/currentuser/UserRole';
import { canAddErrorConditions } from '../../function/permissions';
import SecuredPage from '../../module/SecuredPage';
import { useUserContext } from '../../context/UserContext';

interface Props {
  classType: ClassType;
}

export default ({ classType }: Props): ReactElement => {
  const { pathname } = useLocation();
  const {
    pouzivatel,
    legislationProcess,
  } = useUserContext();

  return (
    <Layout
      isHromadna={classType === ClassType.HROMADNA_PRIPOMIENKA}
      breadcrumbRouteList={[{
        heading: classType === ClassType.HROMADNA_PRIPOMIENKA
          ? routes.hromadnePripomienky.add.name
          : routes.pripomienky.add.name,
        to: pathname,
      }]}
    >
      <SecuredPage
        allowForRoles={[UserRole.PRIPOMIENKOVATEL, UserRole.NELEGISLATIVNA_ORGANIZACIA, UserRole.VEREJNOST]}
        errorPageConditions={canAddErrorConditions(pouzivatel, legislationProcess)}
      >
        <div className="add-pripomienka-page">
          <Heading size="l">
            Nová {classType === ClassType.HROMADNA_PRIPOMIENKA && 'hromadná'} pripomienka
          </Heading>
          <AddPripomienka
            classType={classType}
          />
        </div>
      </SecuredPage>
    </Layout>
  );
};
